export default __webpack_public_path__ + "static/media/bhscale.19620634.svg";